var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("DialogLayout", {
    attrs: { title: _vm.title, visible: _vm.dialogVisible, width: "45em" },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      open: _vm.open
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function() {
          return [
            _c("CheckDataForm", {
              ref: "checkDataForm",
              attrs: { action: "/check-merge-data", billingYmMode: "this" },
              model: {
                value: _vm.checkDataFormModel,
                callback: function($$v) {
                  _vm.checkDataFormModel = $$v
                },
                expression: "checkDataFormModel"
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _c("CheckDataDialogFooter", {
              attrs: { buttonCaption: "チェック" },
              on: { create: _vm.clickCheckData }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }